import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { LogIn, HandHeart, Eye, EyeOff } from 'lucide-react';
import { useAuth } from '../../contexts/AuthContext';
import './AdminLogin.css';

export default function AdminLogin() {
  const [email,   setEmail]   = useState('');
  const [senha,   setSenha]   = useState('');
  const [show,    setShow]    = useState(false);
  const [loading, setLoading] = useState(false);
  const [erro,    setErro]    = useState('');
  const { login } = useAuth();
  const navigate  = useNavigate();

  const submit = async (e: React.FormEvent) => {
    e.preventDefault();
    setLoading(true); setErro('');
    try {
      await login(email, senha);
      navigate('/admin');
    } catch {
      setErro('E-mail ou senha incorretos.');
    } finally { setLoading(false); }
  };

  return (
    <div className="admin-login-page">
      <div className="al-blobs">
        <div className="blob" style={{ width:400,height:400,background:'var(--laranja)',top:'-100px',right:'-80px' }}/>
        <div className="blob" style={{ width:300,height:300,background:'var(--rosa)',bottom:'-60px',left:'-60px' }}/>
        <div className="blob" style={{ width:200,height:200,background:'var(--amarelo)',top:'40%',left:'20%' }}/>
      </div>
      <div className="al-card">
        <div className="al-header">
          <div className="al-logo">
            <HandHeart size={28} />
          </div>
          <div className="al-logo-text">
            <span>Instituto</span>
            <strong>Mãos Estendidas</strong>
          </div>
        </div>
        <h2>Acesso Restrito</h2>
        <p>Painel administrativo do portal do Instituto Mãos Estendidas</p>

        {erro && <div className="alert alert-erro">{erro}</div>}

        <form onSubmit={submit} className="al-form">
          <div className="form-group">
            <label className="form-label">E-mail</label>
            <input
              type="email" value={email} onChange={e => setEmail(e.target.value)}
              required className="form-control" placeholder="admin@maosestendidas.org.br"
              autoComplete="email"
            />
          </div>
          <div className="form-group">
            <label className="form-label">Senha</label>
            <div className="al-senha-wrap">
              <input
                type={show ? 'text' : 'password'} value={senha}
                onChange={e => setSenha(e.target.value)}
                required className="form-control" placeholder="••••••••"
                autoComplete="current-password"
              />
              <button type="button" className="al-eye" onClick={() => setShow(s => !s)}>
                {show ? <EyeOff size={16} /> : <Eye size={16} />}
              </button>
            </div>
          </div>
          <button type="submit" className="btn btn-primary w-full" style={{ justifyContent: 'center' }} disabled={loading}>
            {loading ? 'Entrando…' : <><LogIn size={17} /> Entrar</>}
          </button>
        </form>

        <p className="al-footer">
          <a href="/">← Voltar ao site</a>
        </p>
      </div>
    </div>
  );
}
